import { useSelector } from 'react-redux';

import { Comment } from '../../../components/Comment';
import { getReviewById } from '../../../selectors/reviews';
import { CommentPart } from '../../../components/CommentPart';

interface IAuthorContainerProps {
  reviewId: string;
}

export function CommentContainer({ reviewId }: IAuthorContainerProps) {
  const { comment } = useSelector(getReviewById(reviewId));

  return (
    <Comment title={comment.type}>
      <CommentPart title="Плюсы:" message={comment.positive} />
      <CommentPart title="Минусы:" message={comment.negative} />
    </Comment>
  );
}
